import { createContext } from "react";

export const ProsContext = createContext({}); 